var email;
class hubSpotFormSubmission {
    constructor() {
            // document.querySelector("[data-submit-newsletter]").addEventListener("click" , (event)=>{
            //     console.log("click")
            //     email = document.querySelector("#newsletterFooterCustomerEmail").value;
            //     if (!this.validateEmail(email)){
            //         console.log("invalid email");
            //         document.querySelector("[data-newsletter-error]").classList.remove("d-none");
            //         setTimeout(function() {
            //             document.querySelector("[data-newsletter-error]").classList.add("d-none");
            //           }, 5000); 
            //     }else{
            //         this.submitForm()
            //     }
            // });

           if( document.querySelectorAll("[data-checkout-info-box]").length > 0){
            document.querySelectorAll("[data-checkout-info-box]").forEach(ele=>{
              ele.addEventListener('change', function() {
                if (this.checked) {
                
                    // Checkbox is checked
                  document.querySelectorAll("[data-checkout-btn]").forEach(btn=>{
                    btn.classList.remove("disabled")
                  })
                }else{
                  document.querySelectorAll("[data-checkout-btn]").forEach(btn=>{
                    btn.classList.add("disabled")
                  })
                }
              
            });
            })
           };
      if (window.location.href.includes("/account")) {
  window.location.href = "https://fablelistikeditions.com";
}


            
    };

    validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };
    submitForm(){
        const formData = {
            email: email
          };
          // Define the URL of the conversion page
          const conversionPageUrl = "https://fablelistikeditions.myshopify.com";
          // Make an HTTP POST request to the HubSpot form submission endpoint
          fetch('https://api.hsforms.com/submissions/v3/integration/submit/39563437/6bb2b413-ddd4-46c2-bba7-e351e911948c', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              fields: Object.entries(formData).map(([name, value]) => ({ name, value })),
              context: {
                pageUri: window.location.href,
                pageName: 'HomePage'
              },
              conversionPage: conversionPageUrl
            })
          })
          .then(response => {
            console.log("res", response);
            if (response.ok) {
              console.log('Form submitted successfully');
              document.querySelector("[data-newsletter-suceess]").classList.remove("d-none");
              document.querySelector("[newletter-wrap]").classList.add("d-none");
            //   document.querySelector("[data-heading-text]").classList.add("d-none");
            //   document.querySelector("[hub_spot_thank_you]").classList.remove("d-none");
            //   document.querySelector("[data-hub-spot-form]").classList.add("d-none");
            //   document.querySelector("[data-modal-opener]").classList.add("d-none");
            } else {
              console.error('Error submitting form');
            }
          })
          .catch(error => {
            console.error('Error submitting form:', error);
          });
          
    }


    
}


new hubSpotFormSubmission();